/**
 * Gets styles by a classname
 * 
 * @notice The className must be 1:1 the same as in the CSS
 * @param string className_
 */
function getStyle(className_) {

    var styleSheets = document.styleSheets;
    var styleSheetsLength = styleSheets.length;
    for(var i = 0; i < styleSheetsLength; i++){
        try {
            var classes = styleSheets[i].rules || styleSheets[i].cssRules;
            if (classes !== null) {
                var classesLength = classes.length;
                for (var x = 0; x < classesLength; x++) {
                    if (classes[x].selectorText == className_) {
                        var ret = classes[x].style.cssText;
                        return ret;
                    }
                }
            } else {
                return ' ';
            }
        }
        catch (e) {
        }
    }

}